module.exports = __webpack_public_path__ + "img/火龙果8.565404be.png";